import PageLayout from "../components/UI/Layout/PageLayout";
import { useState } from "react";
import moment from "moment/moment";
import ContentLayout from "../components/UI/Layout/ContentLayout";
import { Tabs } from "../components/UI/Tabs/Tabs";
import HeaderLayout from "../components/UI/Layout/HeaderLayout";
// @ts-expect-error pure js
import useProfileBailleurs from "../hooks/use-profile-bailleurs.js";
// @ts-expect-error pure js
import useProperties from "../hooks/use-properties.js";
// @ts-expect-error pure js
import usePropertyFolders from "../hooks/use-property-folders.js";
// @ts-expect-error pure js
import { useModal } from "../hooks/use-modal.jsx";
import FiscaliteNoSubscription from "../components/Fiscalite/FiscaliteNoSubscription";
import FiscaliteDeclarationsList from "../components/Fiscalite/FiscaliteDeclarationsList";
// @ts-expect-error pure js
import BuyComptabiliteForm from "../components/Stripe/BuyComptabiliteForm.jsx";
import { buildDeclarations } from "../utils/fiscalite";

export default function FiscalitePage() {
  const { profileBailleursById } = useProfileBailleurs({ withById: true });
  const { properties } = useProperties();
  const { propertyFolders } = usePropertyFolders();
  const [ComptabiliteModal, closeComptabiliteModal, openComptabiliteModal] =
    useModal();

  const today = moment();
  const buyComptaFiscalYears =
    today > moment(`${today.year()}-05-31`)
      ? [today.year()]
      : [today.year() - 1, today.year()];
  const [comptaFiscalYear, setComptaFiscalYear] = useState(
    buyComptaFiscalYears[0],
  );

  const declarations = buildDeclarations({
    properties,
    propertyFolders,
    profileBailleursById,
  });
  return (
    <PageLayout isBailleur>
      <BuyComptabiliteForm
        Modal={ComptabiliteModal}
        fiscalYear={comptaFiscalYear}
        onPaymentSuccessful={closeComptabiliteModal}
      />
      <ContentLayout
        header={
          <HeaderLayout
            title="Fiscalité"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Fiscalité" },
            ]}
          />
        }
        body={
          <Tabs id="fiscalite" defaultValue="fiscalite">
            <div className="border-blue">
              <div className="content">
                <Tabs.List>
                  <Tabs.Tab value="fiscalite">Suivi fiscal</Tabs.Tab>
                </Tabs.List>
              </div>
            </div>
            <div className="content marginT20">
              <Tabs.Panel value="fiscalite">
                {declarations.length === 0 ? (
                  <FiscaliteNoSubscription
                    fiscalYears={buyComptaFiscalYears}
                    onSubscribe={(year) => {
                      setComptaFiscalYear(year);
                      openComptabiliteModal();
                    }}
                  />
                ) : (
                  <FiscaliteDeclarationsList declarations={declarations} />
                )}
              </Tabs.Panel>
            </div>
          </Tabs>
        }
      />
    </PageLayout>
  );
}
